import React, { useContext, useEffect, useState } from "react";

import DeliveryNotesPage from "../pages/DeliveryNotesPage";
import { ListActionProvider } from "../actions/list/ListActionContext";
import { RemoveActionProvider } from "../actions/remove/RemoveActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import { GeneratePDFProvider } from "../actions/generate-pdf/GeneratePDFContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { ReplicateActionProvider } from "../actions/replicate/ReplicateActionContext";
import InvoiceAccountSelector from "../../invoice-accounts/components/InvoiceAccountSelector";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";

export default function DeliveryNoteRouterWrapper(props: {
  config?: any;
  filters?: any;
  key?: string;
  formDefaultValues?: any;
  formFilterValues?: any;
  customFormWidgets?: any;
}) {
  const {
    config,
    filters,
    key,
    formDefaultValues,
    formFilterValues,
    customFormWidgets,
  } = props;

  const { commerce } = useContext(TenantAndCommerceContext);
  const { user } = useContext(AuthContext);

  const [deliveryNoteConfiguration, setDeliveryNoteConfiguration] = useState(null);
  const [formDefaultValuesAux, setFormDefaultValuesAux] = useState<{
    issuer_account?: any;
    receiver_account?: any;
  }>({ issuer_account: null, receiver_account: null });
  const [showReceiverAccountSelector, setShowReceiverAccountSelector] =
    useState(true);

  const formWidgets = {
    ...{ receiver_accountable_id: InvoiceAccountSelector },
    ...customFormWidgets,
  };

  useEffect(() => {
    if (commerce && user) {
      const accountData = {
        entity_id: commerce.id,
        entity_type: "App\\Models\\Commerce",
      };
      if (user.role === "admin") {
        setDeliveryNoteConfiguration(commerce.invoice_configuration);
        setFormDefaultValuesAux({
          issuer_account: accountData,
        });
      } else if (user.role === "guide") {
        setShowReceiverAccountSelector(false);
        setDeliveryNoteConfiguration(user.extra_data.invoice_configuration);
        setFormDefaultValuesAux({
          issuer_account: {
            entity_id: user.extra_data.invoice_account.entity_id,
            entity_type: user.extra_data.invoice_account.entity_type,
          },
          receiver_account: accountData,
        });
      }
    }
  }, [commerce, user]);

  return (
    <GeneratePDFProvider>
      <ReplicateActionProvider>
      <ListActionProvider key={key}>
        <RemoveActionProvider>
          <CreateActionProvider>
            <EditActionProvider>
              <DeliveryNotesPage
                formWidgets={formWidgets}
                deliveryNoteConfiguration={deliveryNoteConfiguration}
                formDefaultValues={formDefaultValuesAux}
                config={config}
                filters={filters}
                formFilterValues={formFilterValues}
                showReceiverAccountSelector={showReceiverAccountSelector}
              />
            </EditActionProvider>
          </CreateActionProvider>
        </RemoveActionProvider>
      </ListActionProvider>
      </ReplicateActionProvider>
    </GeneratePDFProvider>
  );
}
